/**
 * Items, not lines (spec 20261008).
 *
 * A quote line (`app.quote_item`) carries a `quantity`: "Behringer B5 x4" is
 * one line and four physical items, and each item is tested. Anything that
 * tells a person how much work was done counts items, the sum of quantity.
 * Lines are named only where they differ, to explain the gap.
 *
 * Shared by the API worker, the warehouse worker and the frontend, so every
 * surface counts the same way.
 */

/** The number of physical items on one line. A missing or invalid quantity is one. */
export function itemQuantity(line) {
  const quantity = Number(line?.quantity);
  return Number.isInteger(quantity) && quantity >= 1 ? quantity : 1;
}

/** The number of physical items across lines. */
export function itemCount(lines) {
  return lines.reduce((total, line) => total + itemQuantity(line), 0);
}

/** "10 items (4 lines)", or "4 items" when every line is one item. */
export function itemCountPhrase(lines) {
  const items = itemCount(lines);
  const phrase = `${items} ${items === 1 ? 'item' : 'items'}`;
  if (items === lines.length) return phrase;
  return `${phrase} (${lines.length} ${lines.length === 1 ? 'line' : 'lines'})`;
}
